import { api_GET, api_POST } from "../api/_axios.js";

const fde_api =
{
    fechar: function (contrato_Id, competencia) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`fde/Fechar`, { contrato_Id, competencia }).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    reabrir: function (contrato_Id, competencia) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`fde/Reabrir`, { contrato_Id, competencia }).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getRelatorio: function (grupoFDE_Id, competencia) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`fde/Relatorio/${grupoFDE_Id}/${competencia}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getRelatorioPorContrato: function (contrato_Id, competencia) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`fde/RelatorioPorContrato/${contrato_Id}/${competencia}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    }
}

export default fde_api;
